import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9 4.75a.75.75 0 0 1 .75.75V9a.75.75 0 0 1-.75.75H5.5A.75.75 0 0 1 4.75 9V5.5a.75.75 0 0 1 .75-.75zm0 6.5A2.25 2.25 0 0 0 11.25 9V5.5A2.25 2.25 0 0 0 9 3.25H5.5A2.25 2.25 0 0 0 3.25 5.5V9a2.25 2.25 0 0 0 2.25 2.25zm0 3a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H5.5a.75.75 0 0 1-.75-.75V15a.75.75 0 0 1 .75-.75zm0 6.5a2.25 2.25 0 0 0 2.25-2.25V15A2.25 2.25 0 0 0 9 12.75H5.5A2.25 2.25 0 0 0 3.25 15v3.5a2.25 2.25 0 0 0 2.25 2.25zM19.25 5.5a.75.75 0 0 0-.75-.75H15a.75.75 0 0 0-.75.75V9c0 .414.336.75.75.75h3.5a.75.75 0 0 0 .75-.75zm1.5 3.5a2.25 2.25 0 0 1-2.25 2.25H15A2.25 2.25 0 0 1 12.75 9V5.5A2.25 2.25 0 0 1 15 3.25h3.5a2.25 2.25 0 0 1 2.25 2.25zm-2.25 5.25a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V15a.75.75 0 0 1 .75-.75zm0 6.5a2.25 2.25 0 0 0 2.25-2.25V15a2.25 2.25 0 0 0-2.25-2.25H15A2.25 2.25 0 0 0 12.75 15v3.5A2.25 2.25 0 0 0 15 20.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }